export default function formatCurrency(value, currency) {
  const locales = {
    BRL: 'pt-BR',
    USD: 'en-US',
    ARS: 'es-AR',
    EUR: 'es-ES',
    GBP: 'en-GB',
  };

  if (!Intl || !Intl.NumberFormat) {
    return value; // TODO: format as R$
  }

  return new Intl.NumberFormat(locales[currency], {
    style: 'currency',
    currency,
  }).format(value);
}
